import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { ADMIN } from "../constants/testIds";
import Logo from "../components/Logo";
import { ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("kl_token", data.token);
      localStorage.setItem("kl_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-editorial flex items-center justify-center px-6 grain">
      <div className="max-w-md w-full">
        <Link to="/"><Logo variant="light" size={64} /></Link>
        <div className="chapter-num text-editorial/50 mt-14 mb-4">ADMIN · SIGN IN</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-none">Studio access.</h1>
        <form onSubmit={submit} className="mt-12 space-y-8">
          <label className="block">
            <span className="chapter-num text-editorial/50 block mb-2">EMAIL</span>
            <input
              data-testid={ADMIN.loginEmail}
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-editorial/30 focus:border-lime_kl outline-none py-3 text-editorial text-lg"
            />
          </label>
          <label className="block">
            <span className="chapter-num text-editorial/50 block mb-2">PASSWORD</span>
            <input
              data-testid={ADMIN.loginPassword}
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-editorial/30 focus:border-lime_kl outline-none py-3 text-editorial text-lg"
            />
          </label>
          <button
            data-testid={ADMIN.loginSubmit}
            disabled={submitting}
            className="btn-kl bg-lime_kl text-obsidian border-lime_kl hover:bg-editorial hover:border-editorial disabled:opacity-60"
          >
            {submitting ? "Signing in…" : "Sign in"} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
        <Link to="/" className="chapter-num text-editorial/50 mt-10 inline-block hover:text-lime_kl">← BACK TO SITE</Link>
      </div>
    </div>
  );
}
